import $ from 'jquery';

import {
	itemsObject,
	getDOMElements,
	addUTMParameters
} from '../common/utilities';

// Import utilities
const {
	isDefined,
	isEmpty
} = _uo.utility;

import ItemCreatorIntegrations from '../item/integrations-grid.js';
import Triggers                from '../item/triggers';
import Actions                 from '../item/actions';

import MetaboxItems            from './items';

class MetaboxFooter {

	constructor( itemType ){
		this.itemType = itemType;

		if ( this.shouldCreateMetaboxFooter() ){
			this.createFooter();
		}
	}

	shouldCreateMetaboxFooter(){
		// Check if we should create the metabox
		// For the triggers we're going to create it always,
		// but for the actions we're going to create only if there is at least one action

		let create = false;

		if ( this.itemType == 'trigger' ){
			// Get triggers
			let recipeActions = itemsObject( 'get', {
				filter: {
					itemType: 'trigger'
				}
			});

			// Check if has triggers
			let hasTriggers = ! isEmpty( recipeActions );

			// Create metabox if hasTriggers
			if ( ( hasTriggers || ( ! isDefined( UncannyAutomator.wp ) || ! UncannyAutomator.wp ) ) || UncannyAutomator.recipe.type == 'anonymous' ){
				create = true;
			}
		}

		if ( this.itemType == 'action' ){
			// Get actions
			let recipeActions = itemsObject( 'get', {
				filter: {
					itemType: 'action'
				}
			});

			// Check if has actions
			let hasActions = ! isEmpty( recipeActions );

			// Create metabox if hasActions
			if ( hasActions || ! isEmpty( UncannyAutomator.recipe.conditions ) ){
				create = true;
			}
		}

		return create;
	}

	createFooter(){
		// Create error container
		let container  = $( '<div/>', { 'class': 'metabox__footer' });

		// "Add another" button
		const $addAnother = document.createElement( 'uo-button' );
		$addAnother.setAttribute( 'color', 'secondary' );

		// Add button, but don't add it in the triggers metabox for anonymous recipes
		if ( this.itemType == 'action' || ( this.itemType == 'trigger' && UncannyAutomator.recipe.type == 'user' ) ){
			// Append "Add another" button
			container.append( $addAnother );
		}

		if ( this.itemType == 'trigger' ){
			// Do only for "user" recipes
			if ( UncannyAutomator.recipe.type == 'user' ){
				// Set text to the "Add Another" button
				$addAnother.innerText = UncannyAutomator.i18n.trigger.addAnother;
			}

			// Do only for "anonymous" recipes
			if ( UncannyAutomator.recipe.type == 'anonymous' ){
				// Create and append anonymous notice
				let $anonymousNotice = this.createAnonymousNotice();
				container.append( $anonymousNotice );
			}
		}

		if ( this.itemType == 'action' ){
			// Set text to the "Add Another" button
			$addAnother.innerText = UncannyAutomator.i18n.action.addAnother;
			container.addClass('add-action-btn');
		}

		// Add button to add filter
		if ( this.itemType == 'action' ){
			container.get(0).insertAdjacentHTML( 'beforeEnd', `
				<ua-builder-conditions-add-button>
					${ UncannyAutomator.i18n.conditions.addFilter }
				</ua-builder-conditions-add-button>
			` );
		}

		// Bind button
		if ( ( this.itemType == 'trigger' && UncannyAutomator.recipe.type == 'user' ) || this.itemType == 'action' ){
			// Listen clicks to the "Add another" button
			$addAnother.addEventListener( 'click', () => {
				// Close any open conditions actions
				new Actions();

				// Multiple triggers are only allowed in the pro version
				// So we're only doing this for actions
				new ItemCreatorIntegrations( this.itemType );
			} );
		}

		// Append to the metabox
		let metabox = getDOMElements( 'metabox', {
			type: this.itemType
		})

		metabox.append( container );
	}

	createAnonymousNotice(){
		let $notice = $( `
			<div class="description">
				${ UncannyAutomator.i18n.recipeType.everyoneOnlyOneTrigger } <a href="${ addUTMParameters( 'https://automatorplugin.com/knowledge-base/managing-triggers/', {
						'medium':  'anonymous_recipe_one_trigger',
						'content': 'learn_more'
					}) }" target="_blank">${ UncannyAutomator.i18n.learnMore } <uo-icon id="external-link"></uo-icon></a>
			</div>
		` );

		return $notice;
	}
}

export default MetaboxFooter;